angular.module('dpw.components').component('dpwBotActions', {
    templateUrl: 'dpw-bot-actions.component.html',
    controllerAs: 'ctrl',
    bindings: {
        application: '<',
        appKeys: '<'
    },
    controller: ['$scope', 'api', 'user', 'freeTierService', 'botErrorHandler', 'dpwAccessService', 'botEnvKeys',
        function ($scope, api, user, freeTierService, botErrorHandler, dpwAccessService, botEnvKeys) {
            var self = this;

            self.botEnvs = {};
            self.botInfo = {};
            self.appKey = {};
            self.canManipulateApp = false;

            self.$onInit = function () {
                self.refreshStatus();
                self.appKey = getAppKey(botEnvKeys.PROD);

                dpwAccessService.canManipulateApp(self.application.id).then(function () {
                    self.canManipulateApp = true;
                });
            };

            self.$onChanges = function (changes) {
                if (changes.application && !changes.application.isFirstChange() && !angular.equals(changes.application.previousValue, changes.application.currentValue)) {
                    self.refreshStatus();
                }
            };

            self.refreshStatus = function () {
                user.fetch().then(function () {
                    const userInfo = user.getUser();

                    getProdBotInfo(userInfo);
                });
            };

            self.onInstall = function (appKeyId, botName, popupCtrl) {
                self.botEnvs[botEnvKeys.PROD].install(appKeyId, botName, popupCtrl, self.refreshStatus);
            };

            self.onUninstall = function (appKeyId) {
                self.botEnvs[botEnvKeys.PROD].remove(appKeyId, self.refreshStatus);
            }

            self.onUpdateBotInfo = function (botInfo) {
                self.botInfo[botEnvKeys.PROD] = botInfo;
            }

            self.showAccessTokenRow = function () {
                return _.get(self.application, 'scope') === 'Private';
            };

            function getProdBotInfo(userInfo) {
                self.actionEnabledInProd = true;
                self.prodVisible = true;

                var prodKey = _.find(self.appKeys, {
                    isProduction: true
                });

                if (!prodKey) {
                    self.prodVisible = false;
                    return;
                }

                self.isFreeAccount = freeTierService.isFreeAccount(userInfo);

                if (self.isFreeAccount) {
                    showErrorMsgInPage('FREE_TIER', botEnvKeys.PROD);
                    return;
                }

                if (!isValidAppBrand(self.application, userInfo, botEnvKeys.PROD)) {
                    showErrorMsgInPage('NO_VALID_APP_BRAND', botEnvKeys.PROD);
                    return;
                }

                api.call(api.botProvision.get({
                    appKeyId: prodKey.id
                }), function (data) {
                    var errorType;
                    // app is suspended or blocked
                    if (!data.isExist && prodKey.status !== 'Active') {
                        errorType = 'NOT_ACTIVE_APP';
                    }
                    // account without installation permission
                    else if (!data.isExist && !data.isAbleToInstall) {
                        errorType = data.reasons[0];
                    }
                    // account without uninstall permission
                    else if (data.isExist && !data.isAbleToUnInstall) {
                        errorType = 'NO_UNINSTALL_PERMISSION';
                    }

                    showErrorMsgInPage(errorType, botEnvKeys.PROD);

                    self.botInfo[botEnvKeys.PROD] = data.botExtension;
                    self.botEnvs[botEnvKeys.PROD] = computeInstallation(data.isExist, botEnvKeys.PROD);
                });
            }

            function computeInstallation(isBotExisted, env) {
                return {
                    isBotExisted: isBotExisted,
                    install: function (appKeyId, botName, popupCtrl, callback) {
                        popupCtrl.botNameOccupied = false;
                        api.call(api.botProvision.install({
                            appKeyId: appKeyId,
                            name: botName
                        }), function () {
                            callback && callback();
                            popupCtrl.close();
                        }, function (data, defaultHandler) {
                            var message = data.status && data.status.message;
                            var installErrors = [
                                'BOT_ALREADY_INSTALLED',
                                'NO_INSTALL_PERMISSION',
                                'HIPAA_COMPLIANCE_ACCOUNT',
                                'BOT_SUBSCRIBE_WEB_HOOK_FAIL',
                                'BOT_CALL_REDIRECT_URI_FAIL'];
                            if (message === 'BOT_NAME_OCCUPIED') {
                                popupCtrl.botNameOccupied = true;
                                return;
                            }

                            if (_.includes(installErrors, message)) {
                                popupErrorMsg(message, env);
                            } else {
                                defaultHandler();
                            }
                            popupCtrl.close();
                        });
                    },
                    remove: function (appKeyId, callback) {
                        api.call(api.botProvision.remove({
                            appKeyId: appKeyId
                        }), function (data) {
                            callback && callback(data);
                        }, function (data, defaultHandler) {
                            var message = data.status && data.status.message;
                            var uninstallErrors = ['BOT_EXT_NOT_EXIST', 'NO_UNINSTALL_PERMISSION'];

                            if (_.includes(uninstallErrors, message)) {
                                popupErrorMsg(message, env);
                            } else {
                                defaultHandler();
                            }
                        });
                    }
                };
            }

            function isValidAppBrand(application, userInfo, env) {
                var brands = _.get(application, 'brands', []);
                return brands.length === 0 || _.includes(brands, botErrorHandler.getBrandId(userInfo, env));
            }

            function popupErrorMsg(errorType, env) {
                botErrorHandler.popupMsg(errorType, $scope, self, env, self.refreshStatus);
            }

            function showErrorMsgInPage(errorType, env) {
                botErrorHandler.showMsgInPage(errorType, self, env);
            }

            function getAppKey(env) {
                return _.find(self.appKeys, {
                    isProduction: env === botEnvKeys.PROD
                });
            }
    }]
});
